import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';
import { MetaField } from '../react/MetaFields';
import { MetaFieldValue } from '../react/MetaFieldValues';
import { ArticleColours } from '../react/product/colourChange';

export const reactEvents = {
  fooBar: new SignalDispatcher(),
  fooBar2: new SimpleEventDispatcher<number>(),
  saveMetaFields: new SimpleEventDispatcher<MetaField[]>(),
  saveMetaFieldValues: new SimpleEventDispatcher<MetaFieldValue[]>(),
  saveColourChange: new SimpleEventDispatcher<ArticleColours>(),
  goToImportEditorById: new SimpleEventDispatcher<number>(),
  externalImportsExist: new SignalDispatcher()
};

// Example
const unsubscribe = reactEvents.fooBar2.subscribe((a) => { console.log(a)});
reactEvents.fooBar2.dispatch(2);
unsubscribe();
